class EightRoxCollection {
  constructor(root) {
    this.root = root;
    this.grid = root.querySelector('[data-collection-grid]');
    this.filterPanel = root.querySelector('[data-filter-panel]');
    this.count = root.querySelector('[data-product-count]');
    this.bindFilter();
    this.bindGridSize();
    this.bindSort();
    this.bindWishlist();
    this.bindSockFilters();
  }

  bindFilter() {
    this.activeFacets = {};
    this.sockFilter = new URLSearchParams(window.location.search).get('socks_filter') || 'all';
    this.root.querySelector('[data-filter-toggle]')?.addEventListener('click', () => {
      this.filterPanel.hidden = !this.filterPanel.hidden;
    });
    this.root.querySelectorAll('[data-facet-group]').forEach((group) => {
      const key = group.dataset.facetGroup;
      group.querySelectorAll('[data-facet-value]').forEach((button) => {
        button.addEventListener('click', () => {
          const value = button.dataset.facetValue;
          const on = button.getAttribute('aria-pressed') !== 'true';
          button.setAttribute('aria-pressed', String(on));
          button.classList.toggle('active', on);
          this.activeFacets[key] = this.activeFacets[key] || new Set();
          if (on) this.activeFacets[key].add(value); else this.activeFacets[key].delete(value);
          this.applyFilters();
        });
      });
    });
    this.root.querySelector('[data-clear-filters]')?.addEventListener('click', () => {
      this.activeFacets = {};
      this.root.querySelectorAll('[data-facet-value]').forEach((b) => { b.setAttribute('aria-pressed', 'false'); b.classList.remove('active'); });
      this.applyFilters();
    });
  }

  cardMatchesFacets(card) {
    for (const [key, set] of Object.entries(this.activeFacets)) {
      if (!set || !set.size) continue;
      const raw = key === 'sizes' ? card.dataset.sizes : key === 'type' ? card.dataset.type : key === 'colour' ? card.dataset.colour : key === 'availability' ? card.dataset.availability : card.dataset.range;
      const values = (raw || '').split(',').map((v) => v.trim()).filter(Boolean);
      if (!values.some((v) => set.has(v))) return false;
    }
    return true;
  }

  cardMatchesSock(card) {
    const filter = this.sockFilter || 'all';
    const title = (card.dataset.title || '').toLowerCase();
    return filter === 'all'
      || (filter === 'grip' && title.includes('grip'))
      || (filter === 'non-grip' && !title.includes('grip') && !title.includes('ankle'))
      || (filter === 'ankle' && title.includes('ankle'))
      || (filter === 'above-ankle' && !title.includes('ankle'));
  }

  applyFilters() {
    const cards = [...this.grid.querySelectorAll('[data-product-card]')];
    const sockNav = this.root.querySelector('[data-socks-navigation]');
    cards.forEach((card) => {
      card.hidden = !(this.cardMatchesFacets(card) && (!sockNav || this.cardMatchesSock(card)));
    });
    const hasActive = Object.values(this.activeFacets).some((s) => s && s.size);
    const clear = this.root.querySelector('[data-clear-filters]');
    if (clear) clear.hidden = !hasActive;
    if (this.count) this.count.textContent = cards.filter((card) => !card.hidden).length;
  }

  bindGridSize() {
    this.root.querySelectorAll('[data-grid-size]').forEach((button) => {
      button.addEventListener('click', () => {
        this.root.querySelectorAll('[data-grid-size]').forEach((item) => item.classList.toggle('active', item === button));
        this.grid.classList.toggle('three', button.dataset.gridSize === 'three');
        this.grid.classList.toggle('four', button.dataset.gridSize === 'four');
      });
    });
  }

  bindSort() {
    this.root.querySelector('[data-sort-select]')?.addEventListener('change', (event) => {
      if (this.root.hasAttribute('data-fallback-collection')) {
        const mode = event.currentTarget.value;
        const cards = [...this.grid.querySelectorAll('[data-product-card]')];
        cards.sort((a, b) => {
          if (mode === 'price-ascending' || mode === 'price-descending') {
            const direction = mode === 'price-ascending' ? 1 : -1;
            return (Number(a.dataset.price) - Number(b.dataset.price)) * direction;
          }
          if (mode === 'title-ascending') return a.dataset.title.localeCompare(b.dataset.title);
          return 0;
        });
        cards.forEach((card) => this.grid.append(card));
        return;
      }
      event.currentTarget.form.submit();
    });
  }

  bindWishlist() {
    this.root.querySelectorAll('[data-wishlist]').forEach((button) => {
      const key = `8rox-saved-${button.dataset.wishlist}`;
      try { button.classList.toggle('is-saved', localStorage.getItem(key) === 'true'); } catch {}
      button.addEventListener('click', () => {
        const saved = !button.classList.contains('is-saved');
        button.classList.toggle('is-saved', saved);
        try { localStorage.setItem(key, String(saved)); } catch {}
      });
    });
  }

  bindSockFilters() {
    const navigation = this.root.querySelector('[data-socks-navigation]');
    if (!navigation || !this.grid) return;
    this.sockNavigation = navigation;

    const filter = new URLSearchParams(window.location.search).get('socks_filter') || 'all';
    this.applySockFilter(filter);

    navigation.querySelectorAll('a').forEach((link) => {
      link.addEventListener('click', (event) => {
        const url = new URL(link.href, window.location.origin);
        const nextFilter = url.searchParams.get('socks_filter') || 'all';
        if (url.pathname === window.location.pathname) {
          event.preventDefault();
          window.history.pushState({}, '', url);
          navigation.querySelectorAll('a').forEach((item) => item.removeAttribute('aria-current'));
          link.setAttribute('aria-current', 'page');
          this.applySockFilter(nextFilter);
        }
      });
    });

    window.addEventListener('popstate', () => {
      this.applySockFilter(new URLSearchParams(window.location.search).get('socks_filter') || 'all');
    });
  }

  applySockFilter(filter) {
    this.sockFilter = filter;
    const cards = [...this.grid.querySelectorAll('[data-product-card]')];
    if (!cards.length) return;
    const details = {
      all: ['Performance socks', 'Ankle and above-ankle compression socks, with or without grip.'],
      grip: ['Grip socks', 'Performance grip socks for your training kit. Available in black and white.'],
      'non-grip': ['Non-grip socks', 'Performance socks with a non-grip sole. Available in black and white.'],
      ankle: ['Ankle compression socks', 'White ankle socks with grip and non-grip soles.'],
      'above-ankle': ['Above-ankle compression socks', 'Black and white compression socks, with or without grip.']
    };
    const [title, copy] = details[filter] || details.all;
    this.root.querySelector('.collection-hero h1').textContent = title;
    this.root.querySelector('.collection-hero > p:last-child').textContent = copy;
    this.sockNavigation?.querySelectorAll('a').forEach((link) => {
      if (link.dataset.socksFilter === filter) link.setAttribute('aria-current', 'page');
      else link.removeAttribute('aria-current');
    });
    this.applyFilters();
  }
}

document.querySelectorAll('[data-collection-page]').forEach((root) => new EightRoxCollection(root));
